export default function imagePlaceholder(
  width: number = 100,
  height: number = 100
) {
  const shimmer = `
    <svg width="${width}" height="${height}" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient id="g">
            <stop stop-color="#F6F8FE" offset="20%" />
            <stop stop-color="#EFF5FF" offset="50%" />
            <stop stop-color="#F6F8FE" offset="70%" />
            </linearGradient>
        </defs>
        <rect width="${width}" height="${height}" fill="#F6F8FE" />
        <rect id="r" width="${width}" height="${height}" fill="url(#g)" />
        <animate href="#r" attributeName="x" from="-${width}" to="${width}" dur="1s" repeatCount="indefinite"  />
    </svg>`;

  const toBase64 = (str: string) =>
    typeof window === "undefined"
      ? Buffer.from(str).toString("base64")
      : window.btoa(str);

  return `data:image/svg+xml;base64,${toBase64(shimmer)}`;
}
